import { InjectionToken } from '@angular/core';

export const DOCUMENT_TRANSFORMER = new InjectionToken('@digitaix/core/documents/DOCUMENT_TRANSFORMER');
